import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
interface OfferCardProps {
  badge?: string;
  title: string;
  subtitle: string;
  oldPrice?: string;
  price: string;
  highlight?: boolean;
  note?: string;
  includes: string[];
  extras?: string[];
  ctaLabel: string;
  ctaHref?: string;
  selected?: boolean;
  onSelect?: () => void;
}
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Pago seguro'
}, {
  icon: ClockIcon,
  label: 'Acceso en 5 min'
}, {
  icon: CheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function OfferCard({
  badge,
  title,
  subtitle,
  oldPrice,
  price,
  highlight = false,
  note,
  includes,
  extras,
  ctaLabel,
  ctaHref,
  selected,
  onSelect
}: OfferCardProps) {
  const isSelected = selected !== false;
  return <div onClick={onSelect} className={`relative flex h-full flex-col rounded-xl p-3 transition-[box-shadow,opacity] duration-150 ease-out sm:rounded-2xl sm:p-7 ${highlight ? 'bg-forest-800 text-cream-50 shadow-lift ring-2 ring-gold-400' : 'bg-cream-50 text-forest-900 ring-1 ring-inset ring-forest-900/10'} ${onSelect && !isSelected ? 'cursor-pointer opacity-80 hover:opacity-100' : ''}`} data-id="element-168" data-mp="1y5n9fe0ri82l">
      {badge ? <span className="absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold-400 px-2 py-0.5 text-[0.5rem] font-bold uppercase tracking-[0.1em] text-forest-950 sm:-top-3 sm:left-5 sm:translate-x-0 sm:px-3 sm:py-1 sm:text-[0.65rem] sm:tracking-[0.12em]" data-id="element-169" data-mp="3n9shzfx98s8">
          {badge}
        </span> : null}

      {onSelect && isSelected ? <span className={`absolute right-2 top-2 inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[0.48rem] font-bold uppercase tracking-wider sm:right-4 sm:top-4 sm:px-2 sm:text-[0.55rem] ${highlight ? 'bg-gold-400 text-forest-950' : 'bg-forest-800 text-gold-400'}`} data-id="element-170" data-mp="3guusy5ywlrqg">
          <CheckIcon className="h-2 w-2 sm:h-2.5 sm:w-2.5" aria-hidden="true" data-id="element-171" data-mp="2o2rh9z0sksbl" />
          <span className="hidden sm:inline" data-id="element-172" data-mp="2j122q9ed1wir">Seleccionado</span>
        </span> : null}

      <h3 className={`mt-3 font-display text-[0.9rem] leading-tight sm:mt-0 sm:max-w-[75%] sm:text-xl ${highlight ? 'text-cream-50' : 'text-forest-900'}`} style={{
      fontWeight: 700
    }} data-id="element-173" data-mp="2f1jjrj63nvik">
        {title}
      </h3>
      <p className={`mt-1 text-[0.62rem] leading-snug sm:text-sm ${highlight ? 'text-cream-200' : 'text-forest-900/60'}`} data-id="element-174" data-mp="36timcodqxwk6">
        {subtitle}
      </p>

      <div className="mt-2.5 flex flex-wrap items-end gap-x-2 gap-y-0.5 sm:mt-5 sm:gap-2.5" data-id="element-175" data-mp="2xx9lr6e18rwg">
        {oldPrice ? <span className={`font-display text-[0.8rem] line-through sm:text-lg ${highlight ? 'text-cream-200/60' : 'text-forest-900/40'}`} data-id="element-176" data-mp="3qfos0odcirjp">
            {oldPrice}
          </span> : null}
        <span className={`font-display text-[1.6rem] leading-none sm:text-[2.75rem] ${highlight ? 'text-gold-400' : 'text-forest-900'}`} style={{
        fontWeight: 700
      }} data-id="element-177" data-mp="3t1emdfhby9fr">
          {price}
        </span>
      </div>
      <p className={`mt-1 text-[0.58rem] sm:text-xs ${highlight ? 'text-cream-200/70' : 'text-forest-900/50'}`} data-id="element-178" data-mp="au8gcfooajvu">
        Pago único · sin suscripción
      </p>

      <ul className="mt-2.5 space-y-1 sm:mt-5 sm:space-y-2" data-id="element-179" data-mp="ftbb97axv9q3">
        {includes.map(item => <li key={item} className="flex items-start gap-1.5 text-[0.65rem] leading-snug sm:gap-2 sm:text-sm" data-id="element-180" data-mp="kqtmj4cfi119">
            <CheckIcon className={`mt-0.5 h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5 ${highlight ? 'text-gold-400' : 'text-forest-600'}`} aria-hidden="true" data-id="element-181" data-mp="plqq3vqxvi6r" />
            <span className={highlight ? 'text-cream-100' : 'text-forest-900/80'} data-id="element-182" data-mp="13iw36fp2lhbi">{item}</span>
          </li>)}
      </ul>

      {extras && extras.length > 0 ? <div className={`mt-2.5 rounded-lg p-2 sm:mt-4 sm:rounded-xl sm:p-3 ${highlight ? 'bg-forest-950/40' : 'bg-cream-100'}`} data-id="element-183" data-mp="puc7fcn35dft">
          <p className={`text-[0.5rem] font-bold uppercase tracking-[0.1em] sm:text-[0.58rem] sm:tracking-[0.12em] ${highlight ? 'text-gold-400' : 'text-forest-600'}`} data-id="element-184" data-mp="zlqdy4dgfdig">
            Solo en este pack
          </p>
          <ul className="mt-1.5 space-y-1 sm:mt-2 sm:space-y-1.5" data-id="element-185" data-mp="2whb0ogvrge8">
            {extras.map(item => <li key={item} className="flex items-start gap-1.5 text-[0.65rem] leading-snug sm:gap-2 sm:text-sm" data-id="element-186" data-mp="gw0kplpcazsn">
                <CheckIcon className={`mt-0.5 h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5 ${highlight ? 'text-gold-400' : 'text-forest-600'}`} aria-hidden="true" data-id="element-187" data-mp="bvw2nr8s9x0b" />
                <span className={highlight ? 'text-cream-50' : 'text-forest-900'} data-id="element-188" data-mp="1ne6zwq0bbpn1">{item}</span>
              </li>)}
          </ul>
        </div> : null}

      {note ? <p className={`mt-2.5 rounded-lg px-2 py-2 text-[0.6rem] leading-snug sm:mt-4 sm:px-3 sm:py-2.5 sm:text-[0.8rem] ${highlight ? 'bg-forest-950/40 text-cream-100' : 'bg-cream-100 text-forest-900/70'}`} data-id="element-189" data-mp="3a6fv07b12ttb">
          {note}
        </p> : null}

      <div className="mt-auto pt-3 sm:pt-5" data-id="element-190" data-mp="3ozjdcgwg1bl3">
        <CtaButton href={ctaHref} size="md" className="w-full !px-2 !text-[0.6rem] sm:!px-6 sm:!text-sm" data-id="element-191" data-mp="3sz9zg7b0z3ja">
          {ctaLabel}
        </CtaButton>
        <ul className={`mt-2 flex flex-wrap justify-center gap-x-2 gap-y-0.5 text-[0.52rem] font-medium sm:mt-3 sm:gap-x-3 sm:gap-y-1 sm:text-[0.7rem] ${highlight ? 'text-cream-200/75' : 'text-forest-900/55'}`} data-id="element-192" data-mp="3f7ddym3v3rvv">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1" data-id="element-193" data-mp="giy02nws3wc6">
              <item.icon className="h-2.5 w-2.5 sm:h-3 sm:w-3" aria-hidden="true" data-id="element-194" data-mp="qckd11ko80bv" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </div>;
}